import React, { useEffect } from 'react';
import * as S from './style';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subText?: string;
  confirmText?: string;
  cancelText?: string;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  subText,
  confirmText,
  cancelText,
  shouldCloseOnOverlayClick,
  shouldCloseOnEsc,
}) => {
  useEffect(() => {
    if (isOpen) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [isOpen]);

  return (
    <S.StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000,
        },
      }}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
    >
      {title && <S.Title>{title}</S.Title>}
      {subText && <S.SubText>{subText}</S.SubText>}
      <S.ButtonContainer>
        <S.LeftButton onClick={onClose}>{cancelText}</S.LeftButton>
        <S.RightButton onClick={onConfirm}>{confirmText}</S.RightButton>
      </S.ButtonContainer>
    </S.StyledModal>
  );
};

export default ConfirmModal;
